<template>
  <div class="px-3 py-4">
    <h3 class="text-header">
      Sender
      <tool-tip text="Shipper is the person or company who supplies the commodity to be shipped." />
    </h3>

    <div class="flex flex-wrap pt-0 justify-between">
      <div class="slice-option  sm:w-5/12 w-full">
        <label class="label">Name</label>
        <input type="text" class="input-mini" placeholder="--Enter--" v-model="sender.contactName" />
      </div>

      <div class="slice-option sm:w-5/12 w-full">
        <label class="label">Email</label>
        <input type="text" class="input-mini" placeholder="--Enter--" v-model="sender.email" />
      </div>

      <div class="slice-option sm:w-5/12 w-full">
        <div class="flex justify-between items-center">
          <label class="label whitespace-no-wrap">Phone Number</label>
          <div class="w-full flex mt-1 gap-4 justify-end">
            <label for="mobilePhone" class="radio-label">
              <input class=" bg-primary-yellow text-secondary-yellow" name="phone" type="radio" id="mobilePhone"
                value="mobile" v-model="sender.mobileNumberType" />
              Mobile
              <span></span>
            </label>

            <label for="fixedPhone" class="radio-label">
              <input type="radio" v-model="sender.mobileNumberType" value="fixed" id="fixedPhone" name="phone" />
              Fixed
              <span></span>
            </label>
          </div>
        </div>
        <vue-tel-input v-model="sender.mobile" class="py-0"></vue-tel-input>
        <span v-if="isPhoneNumberInValid" class="mt-2 text-red-500 inline-block">Phone number is invalid</span>
      </div>

      <div class="slice-option sm:w-5/12 w-full">
        <div class="flex justify-between items-center">
          <label class="label whitespace-no-wrap">Address</label>
          <div class="w-full flex mt-1 gap-4 justify-end">
            <label for="firstAddress" class="radio-label">
              <input class=" bg-primary-yellow text-secondary-yellow" name="address" type="radio" id="firstAddress"
                value="residential" v-model="sender.addressType" />
              Residential
              <span></span>
            </label>

            <label for="lastAddress" class="radio-label">
              <input type="radio" v-model="sender.addressType" value="business" id="lastAddress" name="address" />
              Business
              <span></span>
            </label>
          </div>
        </div>
        <Addressinput class="address_input" placeholder="--Enter Address--" :locationDetails="viewLocationDetails" />
      </div>

      <div class="w-full pb-10 mt-3">
        <hr />
        <div class="mt-6 flex justify-between items-center">
          <b class="inline-block">Delivery Info</b>
          <button @click="displayDeliveryInfo" v-html="showDeliveryInfo
            ? '&HorizontalLine;'
            : `<abbr class='text-xl'>&plus;</abbr>`
            "></button>
        </div>
      </div>

      <div class="lg:w-5/12 w-full pb-10 mt-3" v-show="showDeliveryInfo">
        <div class="w-full flex mt-1 gap-4 justify-start">
          <label for="dropAtTerminal" class="radio-label">
            <input class=" bg-primary-yellow text-secondary-yellow" name="senderShippingMethod" type="radio"
              id="dropAtTerminal" value="Drop-off at Terminal" v-model="senderShippingMethod" />
            Drop-off at Terminal
            <span></span>
          </label>

          <label for="PickAtAddress" class="radio-label">
            <input type="radio" v-model="senderShippingMethod" value="Pick up from my adddress" id="PickAtAddress"
              name="senderShippingMethod" />
            Pick up from my adddress
            <span></span>
          </label>
        </div>

        <p class="text-sm text-primary-green py-1" v-if="senderShippingMethod == 'Drop-off at Terminal'">
          Select where you would like to drop off your package. We will tell you
          the specific terminal to use when you select a shipping service.
        </p>

        <div class="flex justify-between items-center" v-if="senderShippingMethod == 'Drop-off at Terminal'">
          <span>Select Location</span>
          <span><base-checkbox class="mr-1" v-model="currentUserLocation" @change="getUserLocation($event)" />Use my
            current location</span>
        </div>

        <div class="w-full flex items-center bg-gray-100" v-if="senderShippingMethod == 'Drop-off at Terminal'">
          <!-- <auto-complete :customStyle="customAltStyle" :locationDetails="setTerminal" :disabled="changeAddress"
            placeholder="Enter Address" :value="selectTerminal" /> -->
          <Addressinput class="address_input" placeholder="--Enter Address--" :locationDetails="setTerminal" :disabled="changeAddress" :value="selectTerminal"/>
        
          <button class="px-2 -mt-1 text-blue-600" @click="changeAddress = !changeAddress">
            Change
          </button>
        </div>

        <div v-else class="flex items-center">
          <base-checkbox class="mr-1" v-model="viewTimeSelect" @change="resetViewTime" />
          <span>Schedule at a later date</span>
        </div>
        <el-date-picker v-if="viewTimeSelect" placeholder="Select Preferred pick-up date/time" class="w-full full-width"
          v-model="sender.dropDate" :picker-options="{
            disabledDate: (time) => disabledEndDate(time, null),
          }"></el-date-picker>
      </div>

      <div v-show="showDeliveryInfo" class="lg:w-5/12 w-full pb-10 mt-3">
        <base-checkbox v-model="sender.sendShippingUpdates"
          label="Send me status updates regarding my shipment with the email provided." />
      </div>

      <div class="flex w-full items-center justify-between py-4 px-4">
        <button class="underline" @click="$router.go(-1)">
          Back
        </button>
        <primary-button class="shadow-md font-normal" buttonText="Continue" :loading="loading" :disabled="isDisabled"
          @click="submit" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Addressinput from "../../UI/Addressinput.vue";

export default {
  components: { Addressinput },
  computed: {
    isPhoneNumberInValid() {
      let trimTel = this.sender.mobile.replace(/ /g, "")
      return (this.sender.mobile != "" && trimTel.length < 11) || (this.sender.mobile != "" && trimTel.length > 11)
    },
    customStyle() {
      return {
        width: '100%',
        padding: '8px 10px',
        borderRadius: '5px',
        border: '1px solid grey'
      }
    },
    customAltStyle() {
      return {
        width: '100%',
        padding: '8px 10px',
        borderRadius: '5px',
        border: 'none'
      }
    },
    isTerminal() {
      return this.senderShippingMethod != "Pick up from my adddress";
    },
    senderPayload() {
      return {
        ...this.sender,
        isTerminal: this.senderShippingMethod != "Pick up from my adddress",
        terminalAdd: undefined,
        dropDate: this.sender.dropDate
          ? moment(this.sender.dropDate).format("yyyy-MM-DD")
          : this.sender.dropDate,
      };
    },
    fullAddress() {
      return this.extractAddress(this.sender.address);
    },
    selectTerminal() {
      return this.sender.address;
    },
    isDisabled() {
      return (
        !this.sender.email ||
        !this.sender.mobile ||
        (!this.isTerminal && !this.sender.dropDate) ||
        (this.isTerminal && !this.sender.alternativeAddress.lat)
        || !this.sender.address.lat || this.isPhoneNumberInValid
      );
    },
    isUserSending() {
      return this.$store.getters.latestNewShippingForSelf;
    },
  },
  mounted() {
    this.setDropDate()
    this.getDefaultLocation();
    let prevSender = this.$store.getters.latestNewBooking;
    this.sender.id = prevSender?.prevShipper?.id;
    if (this.$store.getters?.latestNewPrevShipper?.id.length) {
      let prevSender = this.$store.getters?.latestNewPrevShipper;

      const cloneSender = {
        address: {
          lat: prevSender?.address?.lat,
          lng: prevSender?.address?.lng,
          name: prevSender?.address?.name,
        },
        email: prevSender?.email,
        addressType: prevSender?.addressType,
        mobileNumberType: prevSender?.mobileNumberType,
        mobile: prevSender?.mobile_no
          ? prevSender?.mobile_no
          : prevSender?.mobile,
        contactName: prevSender.contactName,
      };

      this.sender = {
        ...this.sender,
        ...cloneSender,
      };
    }
  },
  activated() {
    this.getAllTerminalLocation();
  },
  methods: {
    setDropDate() {
      this.sender.dropDate = moment(new Date()).format("yyyy-MM-DD")
      this.$store.dispatch(
        "setBookingSenderDropDate",
        moment(new Date()).format("YYYY-MM-DD")
      );
    },
    resetViewTime() {
      this.viewTimeSelect && (this.sender.dropDate = undefined)
    },
    viewLocationDetails(response) {
      const addressData = {
        name: response?.name,
        lat: response?.lat,
        lng: response?.lng
      }
      this.setAddress(addressData)
    },
    disabledEndDate(date, departureDate) {
      // If departureDate then return valid dates after departureDate
      if (departureDate) {
        return date.getTime() < departureDate;
      } else {
        // If !departureDate then return valid dates after today
        return date.getTime() < Date.now() - 8.64e7;
      }
    },
    async getDefaultLocation() {
      if (this.isUserSending) {
        let user = this.$store.getters.user;
        const cloneUser = {
          address: {
            lat: user?.address?.lat,
            lng: user?.address?.lng,
            name: user?.address?.name,
          },
          email: user?.email,
          addressType: user?.addressType,
          mobileNumberType: user?.mobileNumberType,
          mobile: user?.mobile || user.mobile_no,
          contactName: `${this?.user?.firstname || ""} ${this?.user?.lastname ||
            ""}`,
        };
        this.sender = {
          ...this.sender,
          ...cloneUser,
        };
      }
    },
    displayDeliveryInfo() {
      this.showDeliveryInfo = !this.showDeliveryInfo;
    },
    async getStateName(val) {
      const senderPayload = {
        lat: val.lat,
        long: val.lng,
      };

      await this.$_getStateNameWithDim(senderPayload).then((res) => {
        const cloneAddress = {
          name: `${res.data.address?.streetName}, ${res.data.address?.city}`,
          lat: res.data.address?.latitude,
          lng: res.data.address?.longitude,
        };
        this.sender.alternativeAddress = cloneAddress;
      });
    },
    returnML(val) {
      return val?.locationName + " (" + val?.Org?.companyname + ")";
    },
    async getUserLocation(event) {
      if (!event) return;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          successCallback.bind(this),
          errorCallback
        );
      } else {
        // ..
      }

      function successCallback(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        this.sender.terminalAdd = {
          ...this.sender.terminalAdd,
          lat: latitude,
          lng: longitude,
        };
      }

      function errorCallback() {
        this.handleError("Error getting location");
      }
    },
    changeTab() {
      localStorage.setItem("booking-flow-tab", 2);
    },
    async getAllTerminalLocation() {
      try {
        this.$_newGetAllBookingLocations().then((response) => {
          this.allterminals = response.data.findLocation;
        });
      } catch (error) {
        //
      }
    },
    setAddress(addressData) {
      this.sender = {
        ...this.sender,
        address: {
          name: addressData?.name,
          lat: addressData?.lat,
          lng: addressData?.lng
        },
      };
      console.log(this.sender, addressData)
      if (!this.sender.alternativeAddress.lat) return;
      this.sender = {
        ...this.sender,
        alternativeAddress: {
          name: addressData?.name,
          lat: addressData?.lat,
          lng: addressData?.lng,
        },
      };
    },
    setTerminal(addressData) {
      console.log("setterminal", addressData)
      this.sender = {
        ...this.sender,
        alternativeAddress: {
          name: addressData?.name,
          lat: addressData?.lat,
          lng: addressData?.lng,
        },
      };
    },
    async getShippingService() {
      try {
        let payload = {
          shipperLocationId: this.$store.getters.latestNewBooking.shipper?.id,
          consigneeLocationId: this.$store.getters.latestNewBooking.consignee
            ?.id,
        };
        await this.$_getAllNewShippingService(payload).then(
          async (response) => {
            this.shippingService = response.data.data.shippingServices;
            if (!this.shippingService.length) {
              this.generateToast(
                "Can`t proceed no shipping service available, for the choosen route",
                "error"
              );
              return;
            }
            if (!this.$store.getters.latestNewInitialShipping?.id) {
              await this.createShipping();
              this.$emit("changeBookingTab", 3);
            } else {
              this.$emit("changeBookingTab", 3);
            }
          }
        );
      } catch (error) {
        this.handleError(error);
      }
    },
    async submit() {
      this.loading = true;
      let getmethods =
        this.senderShippingMethod !== "Pick up from my adddress"
          ? "terminal"
          : "door";
      this.$store.dispatch("saveBookingMethodStart", getmethods);
      try {
        const statePayload = { lat: this.sender?.address?.lat, long: this.sender?.address?.lng }
        const state = await this.$_getStateNameWithDim(statePayload)

        const address = {
          ...this.senderPayload.address,
          state: state.data?.state,
          city: state.data?.address?.city
        }
        this.senderPayload.address = address

        const senderPayload = {
          ...this.senderPayload,
          state: state.data?.state,
          city: state.data?.address?.city
        }

        let shippingLocationid = this.$store.getters.latestNewBooking
          ?.prevShipper?.id;
        const response = shippingLocationid
          ? await this.$_updateBookngLodation(senderPayload)
          : await this.$_submitShipperInformation(senderPayload);

        this.$store.dispatch(
          "saveLatestNewBookingShipper",
          response.data.data.location || response.data.data
        );
        this.$store.dispatch("setBookingDropOffDays", this.sender.dropDate);
        this.$store.dispatch("saveBookingChangesIndicator", true);
        // this.getShippingService()
        this.$emit("changeBookingTab", 2);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    "sender.dropDate"(val) {
      this.$store.dispatch(
        "setBookingSenderDropDate",
        moment(val).format("YYYY-MM-DD")
      );
    },
    "sender.terminalAdd"(val) {
      this.getStateName(val);
    },
    senderShippingMethod(val) {
      val != "Drop-off at Terminal" ? (this.sender.dropOff = undefined) : null;
      val && this.getUserLocation();
      val != "Drop-off at Terminal"
        ? (this.isTerminal = true)
        : (this.isTerminal = false);
      switch (val) {
        case "Drop-off at Terminal":
          this.sender.dropDate = undefined;
          this.sender.alternativeAddress = {
            name: this.selectTerminal?.name,
            lat: this.sender.address.lat,
            lng: this.sender.address.lng,
          };
          break;

        case "Pick up from my adddress":
          this.currentUserLocation = false;
          this.sender.alternativeAddress = {};
          this.sender.terminalAdd = {
            lat: "",
            lng: "",
            name: "",
            locality: "",
            country: "",
            street_number: "",
          };
          break;
      }
    },
  },
  data() {
    return {
      showNewBookingModal: false,
      loading: false,
      user: JSON.parse(localStorage.getItem("loggedInUser")),
      shippingService: [],
      locations: [],
      allterminals: [],
      senderShippingMethod: "Pick up from my adddress",
      changeAddress: true,
      currentUserLocation: false,
      showDeliveryInfo: true,
      viewTimeSelect: false,
      sender: {
        address: {
          lat: "",
          lng: "",
          name: "",
          locality: "",
          country: "",
          street_number: "",
        },
        terminalAdd: {
          lat: "",
          lng: "",
          name: "",
          locality: "",
          country: "",
          street_number: "",
        },
        dropDate: moment(new Date()).format("yyyy-MM-DD"),
        alternativeAddress: {},
        id: undefined,
        dropOff: undefined,
        type: "takeoff",
        contactName: "",
        email: "",
        mobile: "",
        mobileNumberType: "mobile",
        addressType: "residential",
        sendShippingUpdates: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.text-header {
  font-size: 24px;
  font-weight: 500;
  @apply py-4;
}

.slice-option {
  @apply mt-8;
}

.input-mini {
  @apply bg-gray-100 w-full py-2 px-2 border-2 border-gray-300 rounded-md;
}

.label {
  @apply w-full block;
}

.full-width {
  width: 100%;
}
</style>
